var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FieldSelect, FieldText, Modal, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { useCallback, useEffect } from 'react';
import { Field, Form, reduxForm, } from 'redux-form';
import { analytics } from 'app/utils/segment';
import { useDixaMessengerApi } from 'components/settings/components/sections/dixaMessenger/api/apiProvider';
import { withQueues } from 'hocs';
import { useNotifications } from 'hooks/useNotifications';
import { validateName } from 'utils/formValidator';
const MAX_LENGTH = 255;
const validate = (values) => {
    const errors = {};
    if (!values.queue) {
        errors.queue = 'Please select a queue';
    }
    return errors;
};
export function AddModalImpl(props) {
    const { show, onAdd, onClose, handleSubmit, queues, destroy: destroyForm, } = props;
    const messengerApi = useDixaMessengerApi();
    const notify = useNotifications();
    const handleFormSubmit = useCallback((values) => __awaiter(this, void 0, void 0, function* () {
        const { name, queue } = values;
        analytics.messengerFormSubmitted({ mode: 'create' });
        try {
            const newMessenger = yield messengerApi.create(name, queue);
            notify({
                title: 'Messenger was added',
                text: `You can start settings up "${name}" now.`,
                icon: 'done',
                className: 'success',
                time: 5000,
            });
            onAdd(newMessenger);
        }
        catch (_a) {
            notify({
                title: 'An error occurred',
                text: `An error occurred when trying to add the messenger.`,
                icon: 'exclamation',
                className: 'danger',
            });
        }
    }), [notify, onAdd, messengerApi]);
    const handleQueueSearchToggle = useCallback((open) => {
        if (open) {
            queues.searchTermChange('');
        }
    }, [queues]);
    useEffect(() => {
        if (!show) {
            destroyForm();
        }
    }, [destroyForm, show]);
    return (_jsx(Modal, Object.assign({ isOpen: show, onClose: onClose }, { children: _jsxs(Box, Object.assign({ width: "600px" }, { children: [_jsx(ModalHead, { title: "Add a new messenger", onClose: onClose }), _jsxs(Form, Object.assign({ onSubmit: handleSubmit(handleFormSubmit) }, { children: [_jsxs(ModalBody, { children: [_jsx(Field, { component: FieldText, label: "Name", maxLength: MAX_LENGTH, name: "name", placeholder: "Messenger name", required: true, type: "text", validate: validateName }), _jsx(Field, { component: FieldSelect, items: queues.items, label: "Queue", loading: queues.getItemsAsyncStatus === 'loading', name: "queue", placeholder: "Please select a queue", required: true, searchable: true, onSearch: queues.searchTermChange, onToggle: handleQueueSearchToggle, pagination: {
                                        infinite: true,
                                        nextEnable: queues.hasNextPage,
                                        onNext: queues.nextPage,
                                    } })] }), _jsx(ModalFoot, { cancelOnClick: onClose, confirmName: "Add messenger", confirmOnClick: handleSubmit(handleFormSubmit), confirmProps: { type: 'submit' } })] }))] })) })));
}
export const AddModal = reduxForm({
    enableReinitialize: true,
    form: 'createMessengerForm',
    touchOnBlur: false,
    validate,
})(withQueues(AddModalImpl, { infinite: true }));
